import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const cleaningRequestService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.cleaningRequest.base, data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    getByCurrentUser: async (params) => {
        try {
            const res = await axiosService.get(endPoints.cleaningRequest.byCurrentUser, {
                params
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.cleaningRequest.base}${id}`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    updateById: async (id, data) => {
        try {
            const res = await axiosService.patch(`${endPoints.cleaningRequest.base}${id}/`, {...data});

            return res;
        } catch (error) {
            throw error;
        }
    },
    getFiltered: async (params) => {
        try {
            const res = await axiosService.get(endPoints.cleaningRequest.base, {
                params,
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    deleteById: async (id) => {
        try {
            const res = await axiosService.delete(`${endPoints.cleaningRequest.base}${id}/`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    // Reschedule an EXPIRED request: flips it back to CREATED with a new datetime
    reschedule: async (id, request_datetime) => {
        try {
            const res = await axiosService.patch(endPoints.cleaningRequest.reschedule(id), {request_datetime});

            return res;
        } catch (error) {
            throw error;
        }
    },
    // Deactivate a request: sets status to CANCELED
    deactivate: async (id) => {
        try {
            const res = await axiosService.post(endPoints.cleaningRequest.deactivate(id), {});

            return res;
        } catch (error) {
            throw error;
        }
    },
}

export {
    cleaningRequestService,
}
